<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>

    <side-bar :is-small="$store.state.sideBarIsSmall" :class="$store.state.sideBarIsSmall ? 'shrunk-side-bar' : ''">
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/dashboard" v-if="isApplicationAdmin || isViwerAdmin">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/application-management" v-if="isApplicationAdmin || isViwerAdmin">
        <md-icon>apps</md-icon>
        <p>Application Management</p>
      </sidebar-link>
      <sidebar-link to="/logs" v-if="isApplicationAdmin || isViwerAdmin">
        <md-icon>history</md-icon>
        <p>Auth. Reports</p>
      </sidebar-link>
      <sidebar-link to="/user-management" v-if="isApplicationAdmin || isViwerAdmin">
        <md-icon>person</md-icon>
        <p>User Management</p>
      </sidebar-link>
      <sidebar-link to="/hardware-otps" v-if="isApplicationAdmin || isViwerAdmin">
        <md-icon>credit_card</md-icon>
        <p>hardware OTPs</p>
      </sidebar-link>
      <sidebar-link to="/server-info" v-if="isServerAdmin">
        <md-icon>bar_chart</md-icon>
        <p>Server Info</p>
      </sidebar-link>
      <sidebar-link to="/server-configuration" v-if="isServerAdmin">
        <md-icon>settings</md-icon>
        <p>Server Configuration</p>
      </sidebar-link>
      <sidebar-link to="/admin-management" v-if="isServerAdmin">
        <md-icon>support_agent</md-icon>
        <p>Admin Management</p>
      </sidebar-link>
      <sidebar-link to="/audit" v-if="isServerAdmin">
        <md-icon>assignment</md-icon>
        <p>Audit</p>
      </sidebar-link>
      <a @click="shrinkSideBar"
         class="shrink-side-bar md-list-item-router md-list-item-container md-button-clean md-layout"
         :class="$store.state.sideBarIsSmall ? '' : 'rotate-arrow'"
      >
        <md-icon>double_arrow</md-icon>
        <p v-if="!$store.state.sideBarIsSmall">Shrink the panel</p>
      </a>
      <!-- <sidebar-link to="/sso-management">
        <md-icon></md-icon>
        <p>SSO</p>
      </sidebar-link> -->
    </side-bar>

    <div
      class="main-panel"
      :style="$store.state.sideBarIsSmall ? 'width: calc(100% - 85px);' : ''"
    >
      <top-navbar :links="links"></top-navbar>

      <dashboard-content></dashboard-content>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
  },
  computed: {
    isApplicationAdmin() {
      return window.localStorage.getItem("adminGroups").includes("application_admins");
    },
    isViwerAdmin() {
      return window.localStorage.getItem("adminGroups").includes("viewer_admins");
    },
    isServerAdmin() {
      return window.localStorage.getItem("adminGroups").includes("server_admins");
    },
    links() {
      let here = {
        name: this.$route.name,
        path: this.$route.path,
      };
      if (this.$store.state.breadCrumbs[this.$route.name]) {
        return [...this.$store.state.breadCrumbs[this.$route.name], ...[here]];
      } else {
        return [here];
      }
    },
  },
  methods: {
    shrinkSideBar() {
      this.$store.state.sideBarIsSmall = !this.$store.state.sideBarIsSmall;
      window.localStorage.setItem("sideBarIsSmall", this.$store.state.sideBarIsSmall);
    },
    readConfig() {
      this.$store.state.sideBarIsSmall = window.localStorage.getItem("sideBarIsSmall") === "true";
      window.localStorage.setItem("sideBarIsSmall", this.$store.state.sideBarIsSmall);
    },
  },
  updated() {},
  mounted() {
    this.readConfig();
  },
};
</script>
<style scoped lang="scss">
.rotate-arrow i {
  transform: rotate(180deg);
}

.shrink-side-bar {
  height: 45px;
  padding: 10px 15px;
  margin: 10px 15px;
  text-align: center;
  width: auto;
  cursor: pointer;
  margin-top: auto;
  color: white !important;
}

.shrink-side-bar:hover {
  color: white !important;
}

.shrunk-side-bar {
  .nav p {
    display: none;
  }
}
</style>
